import { AxiosError, AxiosResponse } from 'axios'

import httpStatusCode from '@/data/httpStatusCode'
import { PendingUserOptions } from '@/lib/class/PendingUser'
import identifyVisitor from '@/sdk/careshipTracking/src/collector/identifyVisitor'
import logger from '@/sdk/logger'
import { getAndSaveUserToken, request } from '@/sdk/oauth'

export function logIn(credentials) {
  return new Promise(async (resolve, reject) => {
    const authIsValid = await getAndSaveUserToken(
      credentials.email,
      credentials.password,
    )

    if (authIsValid !== true) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(false)
    } else {
      identifyVisitor()
      resolve(true)
    }
  })
}

export function linkGoogleCIDToCustomer(cid = '', customerId) {
  if (cid === '') {
    return false
  }

  return request
    .post(`tracking/customer-cid/${customerId}`, { cid })
    .then(response => response.data)
    .catch(error => error)
}

export function createUserAccount(
  payload: PendingUserOptions,
): Promise<string> {
  return request
    .post('customer/register', payload)
    .then((response: AxiosResponse) => response.data.customer_id)
    .catch((error: AxiosError) => {
      const { data, status } = error.response
      const isEmailError =
        data === 'User already exists.' || status === httpStatusCode.BAD_REQUEST

      if (isEmailError) {
        throw new Error('EMAIL_EXISTS')
      }

      logger.error('failed trying to create the user account', {
        error,
        tags: ['registration', 'http', 'user', 'account'],
      })

      throw new Error('SERVER_ERROR')
    })
}
